import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarRef,
  MatSnackBarVerticalPosition,
  TextOnlySnackBar,
} from '@angular/material/snack-bar';
import {
  NotificationComponent,
  NotificationData,
} from '../shared/components/notification/notification.component';
import { ComponentType } from '@angular/cdk/portal';

// this needs to match what is in src/styles.scss
export type SnackBarPanelClass =
  | 'success-snackbar'
  | 'error-snackbar'
  | 'deleted-snackbar';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(private _snackBar: MatSnackBar) {}

  openSnackBar(
    message: string,
    action: string,
    panelClass: SnackBarPanelClass = 'success-snackbar',
    configuration: MatSnackBarConfig = {
      duration: 5000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass,
    },
  ): MatSnackBarRef<TextOnlySnackBar> {
    return this._snackBar.open(message, action, configuration);
  }

  openSnackbarFromComponent(
    component: ComponentType<unknown> = NotificationComponent,
    configuration: MatSnackBarConfig<NotificationData>,
  ) {
    return this._snackBar.openFromComponent(component, configuration);
  }
}
